<template>
  <div class="project">
    <ProjectHero :content="project" :projects="projects"></ProjectHero>
    <ProjectDescription v-if="project && project.description" :content="project.description"></ProjectDescription>
    <ProjectContent v-if="project && project.content" :content="project.content"></ProjectContent>
  </div>
</template>

<script>
import ProjectHero from "../components/ProjectHero";
import ProjectDescription from "../components/ProjectDescription";
import ProjectContent from "../components/ProjectContent";
import { db } from "../services/firebase";

const projects = db.collection("projects");

export default {
  name: "project",
  components: {
    ProjectHero,
    ProjectDescription,
    ProjectContent
  },
  data() {
    return {
      project: {
        description: {},
        content: ""
      },
      projects: []
    };
  },
  async created() {
    await this.getProject();
  },
  methods: {
    getProject: function () {
      this.$bind("project", projects.doc(this.$route.params.id));

      db.collection("projects")
        .get()
        .then((docs) => {
          let projectsColl = [];

          docs.forEach(function (doc) {
            let newDoc = doc.data();
            newDoc.id = doc.id;
            projectsColl.push(newDoc);
          });

          this.projects = projectsColl;
        });
    }
  },
  watch: {
    $route: function (to, from) {
      this.getProject();
    }
  },
  mounted() {
    document.getElementById("main").scrollTo(0, 0); // go to top
  }
};
</script>

<style scoped lang="sass">
.project
  /**/
</style>
